export function useLoginPageUrl() {
  const route = useRoute<"product">()

  return computed(() => {
    if (route.params.product) {
      return `/produkter/${route.params.product}/logg-inn`
    } else {
      return undefined
    }
  })
}
